import React from 'react';
import Header from './layout/Header';
import Dashboard from './pages/Dashboard';
import Login from './Auth/Login';
import Books from './pages/books/Books';
import Profile from './pages/Profile';
import ViewBook from './pages/books/ViewBook';
import OldBooks from './pages/books/OldBookList';
import AddorEditBook from './pages/books/AddorEditBook';
import BookCategory from './pages/bookCategory/BookCategory';
import Authors from './pages/authors/Authors';
import AuthorDetails from './pages/authors/AuthorDetails';
import AddorEditAuthor from './pages/authors/AddorEditAuthor';
import Testimonials from './pages/testimonials/Testimonials';
import Announcements from './pages/events/Announcements';
import Banner from './pages/banner/Banner';

const routes = [
    {
        path: '/',
        component: Dashboard,
        auth: true,
    },
    {
        path: '/dashboard',
        component: Dashboard,
        auth: true,
    },
    {
        path: '/books',
        component: Books,
        auth: true,
    },
    {
        path: '/login',
        component: Login,
        auth: false,
    },
    {
        path: '/profile',
        component: Profile,
        auth: true,
    },
    {
        path: '/old-books',
        component: OldBooks,
        auth: true,
    },
    {
        path: '/view-book/:id',
        component: ViewBook,
        auth: true,
    },
    {
        path: '/update-book/:id',
        component: AddorEditBook,
        auth: true,
    },
    {
        path: '/book-categories',
        component: BookCategory,
        auth: true,
    },
    {
        path: '/authors',
        component: Authors,
        auth: true,
    },
    {
        path: '/view-author/:id',
        component: AuthorDetails,
        auth: true,
    },
    {
        path: '/edit-author/:id',
        component: AddorEditAuthor,
        auth: true,
    },
    {
        path: '/add-author',
        component: AddorEditAuthor,
        auth: true,
    },
    {
        path: '/add-book',
        component: AddorEditBook,
        auth: true,
    },
    {
        path: 'testimonials',
        component: Testimonials,
        auth: true
    },
    {
        path: 'announcements',
        component: Announcements,
        auth: true
    },
    {
        path: 'banner',
        component: Banner,
        auth: true
    }
];

export default routes;